import React from 'react';

export const Empty = () => {
  return (
    <article className="emptyView">
      <p>페이지를 찾을 수 없습니다.</p>
    </article>
  );
};
